import { ApiErrorI } from 'util/api.rxjs';

export const isApiError = <T>(data: T | ApiErrorI): data is ApiErrorI => {
    return (data as ApiErrorI).error;
};
